const topics = [
  { label: '4K蓝光', icon: 'ri-4k-fill', count: '12.8万讨论', hot: true },
  { label: '悬疑烧脑', icon: 'ri-brain-line', count: '9.6万讨论', hot: true },
  { label: '科幻巨制', icon: 'ri-planet-line', count: '8.3万讨论', hot: false },
  { label: '高分韩剧', icon: 'ri-heart-pulse-line', count: '11.2万讨论', hot: true },
  { label: '国产新片', icon: 'ri-flag-2-line', count: '7.5万讨论', hot: false },
  { label: '动画电影', icon: 'ri-emotion-line', count: '6.8万讨论', hot: false },
  { label: '纪录片', icon: 'ri-camera-lens-line', count: '5.4万讨论', hot: false },
  { label: '经典重温', icon: 'ri-history-line', count: '10.1万讨论', hot: true },
  { label: '动作大片', icon: 'ri-sword-line', count: '8.9万讨论', hot: false },
  { label: '喜剧专场', icon: 'ri-emotion-happy-line', count: '7.2万讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">热门话题</h2>
          <p className="mt-3 text-sm text-foreground-500">看看大家都在讨论哪些高清影视内容</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.label}
              className={`flex items-center gap-3 px-5 py-3 rounded-xl border cursor-pointer transition-all hover:scale-105 ${
                topic.hot
                  ? 'bg-primary-100 border-primary-300'
                  : 'bg-background-100 border-background-200 hover:border-background-300'
              }`}
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg ${
                topic.hot ? 'bg-primary-500 text-white' : 'bg-secondary-100 text-secondary-600'
              }`}>
                <i className={`${topic.icon} text-base`}></i>
              </div>
              <div className="text-left">
                <p className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{topic.label}</p>
                <p className="text-xs text-foreground-500">{topic.count}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}